export const notificationsPageTranslations = {
  en: {
    notifications_title: "Notifications",
    chatnotifications_title: "Chat Notification",
    no_notifications: "No notifications yet",
    no_notifications_description: "You'll see notifications here when they arrive",
    notifications_aria_label: "Notifications",
  },
  de: {
    notifications_title: "Benachrichtigungen",
    chatnotifications_title: "Chat-Benachrichtigung",
    no_notifications: "Noch keine Benachrichtigungen",
    no_notifications_description: "Sie sehen hier Benachrichtigungen, wenn sie eintreffen",
    notifications_aria_label: "Benachrichtigungen",
  },
  hr: {
    notifications_title: "Obavijesti",
    chatnotifications_title: "Chat obavijest",
    no_notifications: "Trenutno nema obavijesti",
    no_notifications_description: "Ovdje ćete vidjeti obavijesti čim stignu",
    notifications_aria_label: "Obavijesti",
  }
};